export enum EScheduleItemEntity {
  STORE = 'STORE',
  AD_SENSE_AD = 'AD_SENSE_AD',
}
